/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, Input, Output, EventEmitter } from "@angular/core";
import { ParameterValue } from "../simple-function-action-editor.component";

@Component({
  selector: 'app-function-parameter-editor-boolean',
  templateUrl: './boolean-function-parameter-editor.component.html'
})
export class BooleanFunctionParameterEditorComponent {

  @Input()
  parameterValue: ParameterValue;

  @Output()
  valueChange = new EventEmitter<void>();

  get selectedBoolean(): boolean {
    if (this.parameterValue != null && this.parameterValue.mValue != null) {
      return this.parameterValue.mValue == 'true';
    }
    return false;
  }
  set selectedBoolean(selectedBoolean: boolean) {
    if (this.parameterValue != null) {
      this.parameterValue.mValue = selectedBoolean? 'true' : 'false';
      this.valueChange.emit();
    }
  }

  constructor(
  ) {}

}
